/*
Replace
lesson with your resource Name :) Take care about different writings!
/!\ Lesson lesson Lessons lessons /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const lessonSlice = createSlice({
  name: "lessons",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
  },
});

export const {
  list: listLessons,
  show: showLesson,
  create: createLesson,
  update: updateLesson,
} = lessonSlice.actions;

export const actions = lessonSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const lessons = (state) =>
  state.lessons.idsList.map((id) => state.lessons.dictionary[id]);
export const lesson = (state) =>
  state.lessons.showId && state.lessons.dictionary[state.lessons.showId];
export const lessonAttributes = (state) => lesson(state)?.attributes;
export const lessonRelationships = (state) => lesson(state)?.relationships;
export const lessonId = (state) => state.lessons.showId;

export const getLesson = createSelector(
  (state) => state.lessons.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getLessonAttributes = createSelector(
  (state) => state.lessons.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getLessonRelationships = createSelector(
  (state) => state.lessons.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getLessons = createSelector(
  (state) => state.lessons.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default lessonSlice.reducer;
